import React from 'react';
import { translate } from '../translations';
import { getTheme } from '../Theme';

import tempImg from '../images/contact_navImg.png';

import inventor from '../images/engines_Filipek.png';
import engine from '../images/engines_engine1.png';
import microcontroller from '../images/microcontroller.jpg';
import hr from '../images/hr.png';
import nd_hr from '../images/nd_hr.png';

import { ReactComponent as satellite } from '../icons/engines/satellite.svg';
import { ReactComponent as drone } from '../icons/engines/drone.svg';
import { ReactComponent as washingMachine } from '../icons/engines/washingMachine.svg';
import { ReactComponent as drill } from '../icons/engines/drill.svg';
import { ReactComponent as bicycle } from '../icons/engines/bicycle.svg';
import { ReactComponent as windmill } from '../icons/engines/windmill.svg';
import { ReactComponent as tableFan } from '../icons/engines/tableFan.svg';
import { ReactComponent as car } from '../icons/engines/electric-car.svg';

const engineBenefits = [
  {
    text: 'Lżejsze w porównaniu z klasycznymi silnikami BLDC (nawet o 40%)',
    color: 'green'
  },
  { text: 'Nie zużywają dużo energii', color: 'red' },
  { text: 'Odporne na korozję', color: 'yellow' },
  { text: 'Brak hamujących sił zaczepowych', color: 'violet' },
  { text: 'Praca jako silnik lub prądnica', color: 'darkblue' },
  { text: 'Łatwe w wykonaniu', color: 'blue' },
  { text: 'Tańsze w produkcji', color: 'grey' }
];
const engineImplementations = [
  { text: 'techniki kosmiczne', icon: satellite, side: 'left' },
  { text: 'drony, modelarstwo', icon: drone, side: 'right' },
  { text: 'sprzęt AGD', icon: washingMachine, side: 'left' },
  { text: 'elektronarzędzia', icon: drill, side: 'right' },
  { text: 'rowery elektryczne', icon: bicycle, side: 'left' },
  { text: 'elektrownie wiatrowe (prądnice)', icon: windmill, side: 'right' },
  { text: 'wentylatory', icon: tableFan, side: 'left' },
  { text: 'pojazdy elektryczne', icon: car, side: 'right' },
];

function EngineImplementations({ props }) {
  const SvgIcon = props.icon;
  return (
    <div className={getTheme('col-md-6')}>
      <div
        className={props.side === 'left' ? 'col-inner-left' : 'col-inner-right'}
      >
        <SvgIcon className={getTheme('engine-icons')} />
        <p className={getTheme('engine-implementations-p')}>
          {translate(props.text)}
        </p>
      </div>
    </div>
  );
}

const Engines = () => {
  return (
    <>
      <section id="engine">
        <img className={getTheme('template-img')} src={tempImg} alt={'test'} />
        <div className="container">
          <div className={getTheme('row')}>
            <div className={getTheme('col-md-6')}>
              <div className="col-inner-center">
                <img src={inventor} alt={'inventor'} />
              </div>
            </div>

            <div className={getTheme('col-md-6')}>
              <div style={{ marginTop: '6%' }} className="col-inner-center">
                <h4 className={getTheme('engine-h4')}>
                  {translate('Konstrukcja dr inż. Przemysława Filipka')}
                </h4>
                <h3 className="engine-h3">
                  {translate(
                    'Silniki LMB to innowacyjne, bezrdzeniowe, bezszczotkowe silniki prądu stałego'
                  )}{' '}
                </h3>
                <p
                  className={getTheme('engine-p')}
                  style={{ marginBottom: '50px' }}
                >
                  {translate(
                    'Konstrukcja oparta jest na zasadzie bezpośredniego oddziaływania przewodu z prądem na linię międzybiegunową (LMB) magnesu trwałego.'
                  )}
                  '
                  <br />
                  {translate(
                    'Silniki te nie posiadają stalowego rdzenia, dzięki czemu zyskują wiele zalet w stosunku do silników BLDC: mniejsza masa, brak sił zaczepowych, brak strat magnesowania rdzenia.'
                  )}
                  <br />
                  {translate(
                    'Do Urzędu Patentowego RP przesłano 23 zgłoszenia patentowe urządzeń działających na zasadzie LMB, z czego przyznano juz 7 patentów. Na pozostałe czekamy.'
                  )}
                </p>
              </div>
            </div>
          </div>

          <div className="hr-logo">
            <img
              src={localStorage.getItem('theme') === 'wcag' ? nd_hr : hr}
              alt={'logo'}
            />
          </div>

          <div className={getTheme('row') + ' second-row'}>
            <div className={getTheme('col-md-6')}>
              <div className="col-inner-center">
                <h4
                  className={getTheme('engine-h4')}
                  style={{ marginTop: '5%', textAlign: 'right' }}
                >
                  {translate('Prototypy silników LMB')}
                </h4>
                <h3 className="engine-h3" style={{ textAlign: 'right' }}>
                  {translate(
                    'Silniki LMB nie powstały przez zwykłe usunięcie stalowego rdzenia z silnika BLDC'
                  )}
                </h3>
                <p
                  className={getTheme('engine-p')}
                  style={{ textAlign: 'right' }}
                >
                  {translate(
                    'Opierają się na innej zasadzie pracy i innej konstrukcji niż silniki BLDC. W zasadzie jedyną ich cechą wspólną jest brak szczotek i zastosowanie elektronicznego komutatora z wykorzystaniem czujników hallotronowych.'
                  )}
                  <br />
                  {translate(
                    'Dotychczas budowane prototypy są jednofazowe, ale mogą być dwufazowe lub nawet trójfazowe. Prototypy wykonano z filamentu oraz żywicowych wydruków 3D. Konstrukcja LMB może działać zarówno jako silnik, jak i prądnica.'
                  )}
                </p>
              </div>
            </div>
            <div className={getTheme('col-md-6')}>
              <div className="col-inner-center">
                <img src={engine} alt={'engine'} />
              </div>
            </div>
          </div>

          <div className="hr-logo">
            <img
              src={localStorage.getItem('theme') === 'wcag' ? nd_hr : hr}
              alt={'logo'}
            />
          </div>

          <div className={getTheme('row')}>
            <div className={getTheme('col-md-6')}>
              <div className="col-inner-center">
                <img src={microcontroller} alt={'microcontroller'} />
              </div>
            </div>
            <div className={getTheme('col-md-6')}>
              <div className="col-inner-center">
                <h4 className={getTheme('engine-h4')}>
                  {translate('Sterowniki - analogowy i mikroprocesorowy')}
                </h4>
                <h3 className="engine-h3">
                  {translate(
                    'Elektroniczne sterowniki silników BLDC nie nadają się do sterowania silnikami LMB'
                  )}
                </h3>
                <p className={getTheme('engine-p')}>
                  {translate(
                    'Silinki LMB posiadają własne sterowniki, które mogą być budowane jako analogowe lub mikroprocesorowe, kontrolując wiele parametrów pracy silnika - jak np. jego prędkość obrotową, moc, tryby pracy (stała prędkość obrotowa, stały moment).'
                  )}
                </p>
              </div>
            </div>
          </div>

          {/* <div className='hr-logo'>
               <img src={hr} alt={'test'} />
              </div> */}
        </div>
      </section>

      {/* <section id='engine-benefits'>
          <div className={getTheme('row')}>
              <div className={getTheme('col-md-6')}>
                <div className='col-inner-center'>
                  <img src={inventor} alt={'inventor'} />
                </div>
              </div>
                    
              <div className={getTheme('col-md-6')}>
                <div className='col-inner-center'>
                  <ul>
                    {engineBenefits.map(benefit=> (
                        <li style={{color:benefit.color}}>{benefit.text}</li>
                        ))}
                  </ul>
                </div>
              </div>
          </div>

        </section> */}

      <section id="engine-implementations">
        <div className="container">
          <h3>{translate('Zastosowania')}</h3>
          <ul>
            <div className={getTheme('row')}>
              {engineImplementations.map((e, i) => (
                <EngineImplementations props={e} key={i} />
              ))}
            </div>
          </ul>
        </div>
      </section>

      {/* <div className='section-header'>
        <h2>Silniki</h2>
      </div>
      <div className='section-body'>
        <article>
          <div className='inventor'>
            <img src={inventor} alt='Inventor dr inż. Przemysław Filipek' />
            <p className='text-center'>Wynalazca ze swoim silnikiem LMB</p>
          </div>
          <p className='engines-text'>
  
          </p>
          <div className='engines-container'>
            <div className='engines'>
              <img src={firstEngine} alt='engine' />
              <img src={secondEngine} alt='engine' />
            </div>
            <p className='text-center'>Prototypy silników LMB</p>
          </div>
          <p>
            {' '}

          </p>
          <p>

          </p>
          <p>
            Elektroniczne sterowniki silników BLDC nie nadają się do sterowania
            silnikami LMB. Posiadają one własne sterowniki, które mogą być
            budowane jako analogowe lub mikroprocesorowe, kontrolując wiele
            parametrów pracy silnika - jak np. jego prędkość obrotową, moc,
            tryby pracy (stała prędkość obrotowa, stały moment).
          </p>
          <p>
            Dotychczas budowane prototypy są jednofazowe, ale mogą być dwufazowe
            lub nawet trójfazowe. Prototypy wykonano z filamentu oraz żywicowych
            wydruków 3D. Konstrukcja LMB może działać zarówno jako silnik, jak i
            prądnica.
          </p>
          <p>
            Do Urzędu Patentowego RP przesłano 23 zgłoszenia patentowe urządzeń
            działających na zasadzie LMB, z czego przyznano juz 7 patentów. Na
            pozostałe czekamy.
          </p>
          <p className='bold'>Zalety silnika LMB:</p>
          <div>
            <ul>
              <li>
                - lżejsze w porównaniu z klasycznymi silnikami BLDC (nawet o 40
                %),
              </li>
              Energooszczędność
              <li>- Nie zużywają dużo energii,</li>\
              Wytzymałość
              <li>- odporne na korozję,</li>
              Jakość
              <li>- brak hamujących sił zaczepowych,</li>
              Elastyczność
              <li>- praca jako silnik lub prądnica,</li>
              Prostota
              <li>- łatwe w wykonaniu,</li>
              Cena
              <li>- tańsze w produkcji.</li>
            </ul>
          </div>
          <p className='bold'>Zastosowania:</p>
          <div>
            <ul>
              <li>- drony, modelarstwo,</li>
              <li>- techniki kosmiczne,</li>
              <li>- sprzęt AGD,</li>
              <li>- zabawki,</li>
              <li>- elektronarzędzia,</li>
              <li>- rowery elektryczne,</li>
              <li>- elektrownie wiatrowe (prądnice),</li>
              <li>- wentylatory.</li>
            </ul>
          </div>
          <p>
            Zastosowań jest dużo więcej - wszędzie tam, gdzie można zastosować
            silnik lub prądnicę.
          </p>
        </article>
      </div> */}
    </>
  );
};

export default Engines;
